import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class SidebarCategory extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    img: PropTypes.string,
    inside: PropTypes.bool,
    isNew: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
    hasAccess: PropTypes.bool
  };

  static defaultProps = {
    icon: '',
    inside: false,
    isNew: false,
    hasAccess: false
  };

  constructor() {
    super();
    this.state = {
      collapse: false,
    };
  }

  toggle = () => {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  };

  render() {
    const {
      title, icon, img, inside, isNew, children, hasAccess
    } = this.props;
    const { collapse } = this.state;
    const categoryClass = classNames({
      'sidebar__category-wrap': true,
      'sidebar__category-wrap--open': collapse,
      'sidebar__link sidebar__category': true,
    });

    let imgdir = `${process.env.PUBLIC_URL}/img/`;

    return (
      <div 
      style={{display: hasAccess ? 'block' : 'none'}}
      >
        <button className={categoryClass} type="button" onClick={this.toggle}>

        {img ? <span className={`sidebar__link-icon`}><img src={imgdir+img} alt={img} style={{width: '13px', height: '13px'}} /></span> : 
         ( icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} style={{float: 'left'}} /> : '' )
        }

        {inside ? 
          <p className="sidebar__link-title" style={{paddingLeft: '20px'}}>
            {title}
            {isNew && <span className="sidebar__category-new" />}
          </p> : '' }

        {!inside ? 
          <p className="sidebar__link-title">
            {title}
            {isNew && <span className="sidebar__category-new" />}
          </p> : '' }

          <span className="sidebar__category-icon lnr lnr-chevron-right" />
        </button>
        <Collapse isOpen={collapse} className="sidebar__submenu-wrap">
          <ul className="sidebar__submenu">
            <div>
              {children}
            </div>
          </ul>
        </Collapse>
      </div>
    );
  }
}
